import React from 'react';
import { useHeader } from './useHeader';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { Card } from '../../../../../../../../CommonComponents/OPL/Card/Card';
import { Text } from '../../../../../../../../CommonComponents/OPL/Text/Text';
import { Wrapper } from '../../../../../../../../CommonComponents/OPL/Wrapper/Wrapper';
import { PieChart } from '../../../../../../../../CommonComponents/OPL/charts/PieChart/PieChart';
import { formatPercentage } from '../../../../../../../../CommonUtils/formatNumber';
import { MarginProps } from '../../../../../../../../theme/styledProps';
import { HeaderLoading } from './Header.loading';

export const Header: React.FC<MarginProps> = props => {
  const { data, isFetching } = useHeader();

  if (isFetching) {
    return <HeaderLoading />;
  }

  if (!data) {
    return null;
  }

  const { chartSeries, probabilityOfSuccess, probabilityOfFailure } = data;

  return (
    <Wrapper {...props}>
      <Box display="flex" mt="16" alignItems="stretch">
        <Box width="100%" mr="8" mb="8" display="flex" flexDirection="column">
          <Card p="16" height="100%">
            <Text variant="cardTitle" mb="16">
              Monte Carlo
            </Text>

            <Text variant="smallCaps" mb="8">
              fully funded at retirement
            </Text>

            <Text variant="tabular" fontSize="h3" mb="8" fontWeight={500}>
              {formatPercentage(probabilityOfSuccess, { decimalPlaces: 0 })}
            </Text>

            <Text variant="smallCaps" mb="8">
              money ran out
            </Text>

            <Text variant="tabular" fontSize="h3" fontWeight={500}>
              {formatPercentage(probabilityOfFailure, { decimalPlaces: 0 })}
            </Text>
          </Card>
        </Box>
        <Box width="100%" ml="8" mb="8" display="flex" flexDirection="column">
          <Card p="16" height="100%">
            <Text variant="cardTitle">Probability of success</Text>

            <Box display="flex" alignItems="center" justifyContent="center" flex="1" height="100%">
              <Box width="86px" height="86px">
                <PieChart
                  series={chartSeries}
                  title={formatPercentage(probabilityOfSuccess, { decimalPlaces: 0 })}
                />
              </Box>

              <Text ml="16" color="neutral.500" fontWeight={500} fontSize="small" variant="tabular">
                Target: 70-99%
              </Text>
            </Box>
          </Card>
        </Box>
      </Box>
    </Wrapper>
  );
};
